import React, { useRef, useState } from "react";
import { arrow, arrowDownWard } from "../../../../../public/assets";
import UserRoles from "./UserRoles";
import { styled } from "styled-components";
import { useOutsideAlerter } from "../../../../components/OutsideClickHandler/OutsideClickHandler";
import { setCurrentRole } from "../../../../store/userManagement";
import { useDispatch } from "react-redux";

interface DropDownProps {
  roleTitle: string;
  roles: { type: string; name: string }[];
  onRoleChange: (role: { type: string; name: string }) => void;
  selectedRole?: string;
}

const DropDownSelect: React.FC<DropDownProps> = ({
  roleTitle,
  roles,
  onRoleChange,
}) => {
  const dispatch = useDispatch();
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOutsideAlerter(wrapperRef, setShowDropDown);

  const handleClick = () => {
    setShowDropDown((prev) => !prev);
    dispatch(setCurrentRole(roleTitle));
  };

  return (
    <DropDownWrapper ref={wrapperRef} onClick={handleClick}>
      <span className="role-title">{roleTitle}</span>
      <img src="/assets/Vector.png" alt="" />
      {showDropDown && <UserRoles onRoleChange={onRoleChange} roles={roles} />}
    </DropDownWrapper>
  );
};

export default DropDownSelect;

export const DropDownWrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #e8eaed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.3125rem;

  .role-title {
    white-space: nowrap;
  }
`;
